/* unplugin-vue-components disabled */import { render } from "./IndexEmActivity.vue?vue&type=template&id=6e2893c5&scoped=true"
import script from "./IndexEmActivity.vue?vue&type=script&lang=js"
export * from "./IndexEmActivity.vue?vue&type=script&lang=js"

import "./IndexEmActivity.vue?vue&type=style&index=0&id=6e2893c5&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2893c5"]])

export default __exports__